import _implicitStylesheets from "./blazeYourTrail.css";
import _implicitScopedStylesheets from "./blazeYourTrail.scoped.css?scoped=true";
import _aceLightbox from "ace/lightbox";
import _i18nLink from "i18n/link";
import _adsIcon from "ads/icon";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h6 class="blaze-your-trail-header${0}" type-style="display-7"${2}>${"t1"}</h6>`;
const $fragment2 = parseFragment`<a class="circle-link${0}" href="javascript:void(0)"${2}><img src="/images/blaze_your_trail/blaze-1.png"${"a1:alt"}${3}></a>`;
const $fragment3 = parseFragment`<h6 type-style="display-8"${3}>${"t1"}</h6>`;
const $fragment4 = parseFragment`<a class="circle-link${0}"${"a0:href"} target="_blank"${2}><img src="/images/blaze_your_trail/blaze-2.png"${"a1:alt"}${3}></a>`;
const $fragment5 = parseFragment`<h6 type-style="display-8"${3}>${"t1"}</h6>`;
const $fragment6 = parseFragment`<a class="circle-link${0}"${"a0:href"} target="_blank"${2}><img src="/images/blaze_your_trail/blaze-3.png"${"a1:alt"}${3}></a>`;
const $fragment7 = parseFragment`<h6 type-style="display-8"${3}>${"t1"}</h6>`;
const $fragment8 = parseFragment`<a class="circle-link${0}"${"a0:href"} target="_blank"${2}><img src="/images/blaze_your_trail/blaze-4.png"${"a1:alt"}${3}></a>`;
const $fragment9 = parseFragment`<h6 type-style="display-8"${3}>${"t1"}</h6>`;
const $fragment10 = parseFragment`<h6 type-style="display-8"${3}>${"t1"}</h6>`;
const stc0 = {
  classMap: {
    "component-container": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "blaze-container": true
  },
  key: 4
};
const stc2 = {
  key: 5
};
const stc3 = {
  key: 6
};
const stc4 = {
  key: 9
};
const stc5 = {
  key: 13
};
const stc6 = {
  key: 16
};
const stc7 = {
  key: 20
};
const stc8 = {
  key: 23
};
const stc9 = {
  key: 27
};
const stc10 = {
  key: 30
};
const stc11 = {
  classMap: {
    "blaze-more": true
  },
  key: 34
};
const stc12 = {
  key: 37
};
const stc13 = {
  key: 38
};
const stc14 = {
  key: 39
};
const stc15 = {
  props: {
    "symbol": "content_ebook",
    "spriteSheet": "symbols",
    "size": "small",
    "fill": "#0176D3"
  },
  key: 40
};
const stc16 = {
  key: 42
};
const stc17 = {
  key: 43
};
const stc18 = {
  props: {
    "symbol": "content_ebook",
    "spriteSheet": "symbols",
    "size": "small",
    "fill": "#0176D3"
  },
  key: 44
};
const stc19 = {
  key: 46
};
const stc20 = {
  key: 47
};
const stc21 = {
  props: {
    "symbol": "content_ebook",
    "spriteSheet": "symbols",
    "size": "small",
    "fill": "#0176D3"
  },
  key: 48
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [api_element("div", stc0, [$cmp.showModal ? api_custom_element("ace-lightbox", _aceLightbox, {
    props: {
      "items": $cmp.lightboxItems
    },
    key: 1,
    on: {
      "close": _m0 || ($ctx._m0 = api_bind($cmp.closeModal))
    }
  }) : null, api_static_fragment($fragment1, 3, [api_static_part(1, null, api_dynamic_text($cmp.i18n.blazeYourTrail.sectionTitle))]), api_element("div", stc1, [api_element("ul", stc2, [api_element("li", stc3, [api_static_fragment($fragment2, 8, [api_static_part(0, {
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.watchAction))
    }
  }, null), api_static_part(1, {
    attrs: {
      "alt": $cmp.i18n.blazeYourTrail.watchAltImage
    }
  }, null)]), api_element("div", stc4, [api_static_fragment($fragment3, 11, [api_static_part(1, null, api_dynamic_text($cmp.i18n.blazeYourTrail.watchTitle))]), api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.i18n.blazeYourTrail.watchDescription,
      "ariaLabel": $cmp.i18n.blazeYourTrail.watchDescription
    },
    key: 12,
    on: {
      "videomodal": _m3 || ($ctx._m3 = api_bind($cmp.watchAction))
    }
  })])]), api_element("li", stc5, [api_static_fragment($fragment4, 15, [api_static_part(0, {
    attrs: {
      "href": $cmp.urls.learnUrl
    }
  }, null), api_static_part(1, {
    attrs: {
      "alt": $cmp.i18n.blazeYourTrail.skillAltImage
    }
  }, null)]), api_element("div", stc6, [api_static_fragment($fragment5, 18, [api_static_part(1, null, api_dynamic_text($cmp.i18n.blazeYourTrail.skillTitle))]), api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.i18n.blazeYourTrail.skillDescription,
      "ariaLabel": $cmp.i18n.blazeYourTrail.skillDescription,
      "target": "_blank"
    },
    key: 19
  })])]), api_element("li", stc7, [api_static_fragment($fragment6, 22, [api_static_part(0, {
    attrs: {
      "href": $cmp.urls.shopUrl
    }
  }, null), api_static_part(1, {
    attrs: {
      "alt": $cmp.i18n.blazeYourTrail.shopAltImage
    }
  }, null)]), api_element("div", stc8, [api_static_fragment($fragment7, 25, [api_static_part(1, null, api_dynamic_text($cmp.i18n.blazeYourTrail.shopTitle))]), api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.i18n.blazeYourTrail.shopDescription,
      "ariaLabel": $cmp.i18n.blazeYourTrail.shopDescription,
      "target": "_blank"
    },
    key: 26
  })])]), api_element("li", stc9, [api_static_fragment($fragment8, 29, [api_static_part(0, {
    attrs: {
      "href": $cmp.urls.connectUrl
    }
  }, null), api_static_part(1, {
    attrs: {
      "alt": $cmp.i18n.blazeYourTrail.connectAltImage
    }
  }, null)]), api_element("div", stc10, [api_static_fragment($fragment9, 32, [api_static_part(1, null, api_dynamic_text($cmp.i18n.blazeYourTrail.connectTitle))]), api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.i18n.blazeYourTrail.connectDescription,
      "ariaLabel": $cmp.i18n.blazeYourTrail.connectDescription,
      "target": "_blank"
    },
    key: 33
  })])])]), api_element("div", stc11, [api_static_fragment($fragment10, 36, [api_static_part(1, null, api_dynamic_text($cmp.i18n.blazeYourTrail.infoBoxTitle))]), api_element("ul", stc12, [api_element("li", stc13, [api_element("span", stc14, [api_custom_element("ads-icon", _adsIcon, stc15)]), api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.i18n.blazeYourTrail.infoBoxWhatIsAppExchange,
      "ariaLabel": $cmp.i18n.blazeYourTrail.infoBoxWhatIsAppExchange,
      "target": "_blank"
    },
    key: 41
  })]), api_element("li", stc16, [api_element("span", stc17, [api_custom_element("ads-icon", _adsIcon, stc18)]), api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.i18n.blazeYourTrail.infoBoxBoostEfficiency,
      "ariaLabel": $cmp.i18n.blazeYourTrail.infoBoxBoostEfficiency,
      "target": "_blank"
    },
    key: 45
  })]), api_element("li", stc19, [api_element("span", stc20, [api_custom_element("ads-icon", _adsIcon, stc21)]), api_custom_element("i18n-link", _i18nLink, {
    props: {
      "message": $cmp.i18n.blazeYourTrail.infoBoxFavoriteApps,
      "ariaLabel": $cmp.i18n.blazeYourTrail.infoBoxFavoriteApps,
      "target": "_blank"
    },
    key: 49
  })])])])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-71le75p3tc0";
tmpl.legacyStylesheetToken = "undefined-_blazeYourTrail";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
